export default class WarehouseShopRequest {
    constructor(
        private readonly building: string
    ) {}

    toJson(): {
        building: string;
    } {
        return {
            building: this.building
        };
    }
}